module.exports = __webpack_public_path__ + "img/5.1d8aed80.png";